export default __webpack_public_path__ + "static/media/Xlogo.5604b9ce.svg";